import axios from 'axios';

import {ActionType} from '../actionTypes';

import envManager from '../../com/envManager/EnvManager';

import {Action as FlyerClassesActions} from "../actions/flyerClassesActions";

import {Dispatch} from 'redux';
import {
    ErrorDtoFactory, FlyerClassDto,
    UserDto
} from '../../dtos';

export const getFlyerClasses = () => {

    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<FlyerClassesActions>) => {
        dispatch({
            type: ActionType.GET_FLYER_CLASSES_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerClasses/GetFlyerClasses`;
            let result = await axios.get(url, config);
            const classNone = {
                accountId: -1,
                caption: "Unclassified",
                id: "-1"
            }
            let flyerClassesData = [...result.data.data].map((flyerClass) => {
                return {
                    ...flyerClass,
                    id: flyerClass.id.toString(),
                }
            });

            dispatch({
                type: ActionType.GET_FLYER_CLASSES_SUCCESS,
                payload: [classNone, ...flyerClassesData]
            })

            dispatch({
                type: ActionType.GET_FLYER_CLASSES_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.GET_FLYER_CLASSES_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}


export const deleteFlyerClass = (ids: number[]) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<FlyerClassesActions>) => {
        dispatch({
            type: ActionType.DELETE_FLYER_CLASS_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            let url = `${envManager.flyerEditorServerAddress}/api/FlyerClasses/DeleteFlyerClasses`;
            let result = await axios.post(url, ids, config);
            let data = result.data;

            dispatch({
                type: ActionType.DELETE_FLYER_CLASS_SUCCESS,
                payload: ids
            })
            dispatch({
                type: ActionType.DELETE_FLYER_CLASS_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_FLYER_CLASS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const createFlyerClass = (classesCaption: string[]) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<FlyerClassesActions>) => {
        dispatch({
            type: ActionType.CREATE_FLYER_CLASS_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            let url = `${envManager.flyerEditorServerAddress}/api/FlyerClasses/CreateFlyerClasses`;
            let result = await axios.post(url, classesCaption, config);
            let newClasses = result.data.data;


            dispatch({
                type: ActionType.CREATE_FLYER_CLASS_SUCCESS,
                payload: newClasses
            })
            dispatch({
                type: ActionType.CREATE_FLYER_CLASS_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.CREATE_FLYER_CLASS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const updateFlyerClass = (updateClasses: FlyerClassDto[]) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<FlyerClassesActions>) => {
        dispatch({
            type: ActionType.UPDATE_FLYER_CLASS_START,
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            let url = `${envManager.flyerEditorServerAddress}/api/FlyerClasses/UpdateFlyerClasses`;
            let result = await axios.post(url, updateClasses, config);


            dispatch({
                type: ActionType.UPDATE_FLYER_CLASS_SUCCESS,
                payload: updateClasses
            })
            dispatch({
                type: ActionType.UPDATE_FLYER_CLASS_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.UPDATE_FLYER_CLASS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

